export default {
  labels: {
    radius: 'Rază',
  },
};
